/**
 * The single client-side rule for "how much is this quote worth right now".
 *
 * A quote's `totals` freeze at acceptance, but an approved variation moves the
 * order's contract value and mirrors it onto the quote as `orderContractValue`
 * (display-only — the money Cloud Functions read the OC directly and never
 * trust this field). Any surface that measures money owed must measure against
 * this effective total, not the frozen `totals.grandTotal`: after a variation,
 * a quote fully paid at the frozen total still owes the difference
 * (prod case QTE-2026-0190 / ORD-2026-0044).
 *
 * Same preference `CustomerPaymentPanel` uses — keep them agreeing.
 */
export const effectiveQuoteTotal = (quote: {
  orderContractValue?: number;
  totals?: { grandTotal?: number };
}): number => quote.orderContractValue ?? quote.totals?.grandTotal ?? 0;
